import React, {useEffect, useState} from 'react';
import {NOTIFICATION_TIMER} from '../../utils/ftemConstants';
import './NotificationBar.scss';
import {ReactSVG} from 'react-svg';

const NotificationBar = ({text, type}) => {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        let timer;
        if (isVisible && type === 'success') {
            timer = setTimeout(() => {
                setIsVisible(false);
            }, NOTIFICATION_TIMER);
        }

        return () => {
            if (timer) clearTimeout(timer);
        };
    }, []);

    if (!isVisible) return null;

    return (
        <div className={`sski-notification-bar notification px-4 py-3 ${type} `}>
            <ReactSVG
                onClick={() => setIsVisible(false)}
                src={`${process.env.PUBLIC_URL}/assets/icons/${type}.svg`}
            />
            {text}
        </div>
    );
};

export default NotificationBar;
